/**
 *
 * Asynchronously loads the component for Pricing
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const Notfound = lazyLoad(
  () => import('./index'),
  (module: { Notfound: any }): any => module.Notfound,
);
